import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../Component/Model/helpers';

const descriptionMaxLength: number = 2000;

export const eePlanObjectiveSchema = yup.object({
    yearId: yup.number().nullable().required('Year is required'),
    description: yup.string()
        .required('Description is required')        
        .test('descriptionLengthTest', `Description is too long`, value => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= descriptionMaxLength;
        }),    
    fromDate: yup.date().nullable().required('From date is required'),
    toDate: yup.date().nullable().required('To date is required')
})